// extracted by css-extract-rspack-plugin
export default {"icon":"header-fragment__CustomerAccountFlyout_icon__oEbpQ"};